// Exhaustive deps disabled because it cannot infer what is being passed into the dep array
/* eslint-disable react-hooks/exhaustive-deps */

import { DependencyList, useCallback, useEffect, useRef } from 'react';

export const useRequestCache = <CacheKey, CachedValue>(resetDependencies: DependencyList) => {
    const cache = useRef(new Map<CacheKey, CachedValue>());

    useEffect(function clearCache() {
        cache.current.clear();
    }, resetDependencies);

    const getCached = useCallback((key: CacheKey) => cache.current.get(key), []);

    const setCached = useCallback((key: CacheKey, value: CachedValue) => {
        cache.current.set(key, value);
    }, []);

    return { getCached, setCached };
};
